import React, { useContext } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';
import AddIcon from '@mui/icons-material/Add';
import {
  UnitsCardMainSecondaryEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsCardMainSecondaryText/components/UnitsCardMainSecondaryEntity';
import { RandomInteger } from 'src/helpers/randomInteger';
import { IPlacementHeaderMineElementType } from 'src/components/profileComponents/Marketplace/types';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useStyles } from '../Common/styles';

export const UnitsCardMainSecondaryText: React.FC = () => {
  const styles = useStyles();
  const context = useContext(UnitsDataContext);
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(!!context?.state.unitsOrder.isActive);

  const rocketChange = (state: boolean) => {
    if (context?.state.unitsOrder) {
      context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, firstHeader: { ...current.unitsCard.firstHeader, mainAndSecondary: { ...current.unitsCard.firstHeader.mainAndSecondary, isActive: state } } } }));
      setRocketState(state);
    }
  };

  const add = (type: IPlacementHeaderMineElementType) => {
    if (context) {
      const element = {
        '@id': RandomInteger().toString(),
        diType: type,
        iconFileUri: null,
        prefix: null,
        suffix: null,
        property: {
          diType: 'PlacementProperty' as const,
          oldSystemName: null,
          systemName: '',
          translates: null,
        },
        propertyValue: null,
        styles: {
          fontWeight: 'normal',
          textDecoration: 'none',
          color: '',
          backgroundColor: '',
          borderColor: '',
        },
      };
      context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, firstHeader: { ...current.unitsCard.firstHeader, mainAndSecondary: { ...current.unitsCard.firstHeader.mainAndSecondary, elements: [...current.unitsCard.firstHeader.mainAndSecondary.elements, element] } } } }));
    }
  };

  const moveToTrash = (index: number) => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsCard: {
          ...current.unitsCard,
          firstHeader: {
            ...current.unitsCard.firstHeader,
            mainAndSecondary: {
              ...current.unitsCard.firstHeader.mainAndSecondary,
              elements: current.unitsCard.firstHeader.mainAndSecondary.elements.filter((_, itemIndex) => itemIndex !== index),
            },
          },
        },
      }));
    }
  };

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardMainSecondary}
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
      )}
      >
        {collapseState === GroupWrapperCollapseState.OPEN && (
          <div className={styles.wrapper}>
            <div className={styles.text}>
              { translations.AddAnother1stHeaderElement }
            </div>
            <div className={styles.buttonsWrapper}>
              <MarketplaceButton
                startIcon={<AddIcon />}
                label={translations.mainText}
                onClick={() => add(IPlacementHeaderMineElementType.MAIN)}
              />
              <MarketplaceButton
                startIcon={<AddIcon />}
                label={translations.secondaryText}
                onClick={() => add(IPlacementHeaderMineElementType.SECONDARY)}
              />
            </div>
          </div>
        ) }
      </GroupWrapper>
      {context && (
        <ReactSortable<any>
          className={mainStyles.iteratorWrapper}
          animation={150}
          handle=".drag-handle"
          list={context.state.unitsCard.firstHeader.mainAndSecondary.elements.map((el) => ({ ...el, chosen: false }))}
          setList={(newList, sortable: Sortable | null, store: Store) => {
            if (store && store.dragging && store.dragging.props
              && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
              context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, firstHeader: { ...current.unitsCard.firstHeader, mainAndSecondary: { ...current.unitsCard.firstHeader.mainAndSecondary, elements: newList } } } }));
            }
          }}
        >
          {collapseState === GroupWrapperCollapseState.OPEN && context?.state.unitsCard.firstHeader.mainAndSecondary.elements.map((item, index) => (
            <React.Fragment key={item['@id']}>
              <UnitsCardMainSecondaryEntity
                title={item.diType === IPlacementHeaderMineElementType.MAIN ? translations.mainText : translations.secondaryText}
                entity={item}
                onChange={(entity) => context.updateState((current) => ({
                  ...current,
                  unitsCard: {
                    ...current.unitsCard,
                    firstHeader: {
                      ...current.unitsCard.firstHeader,
                      mainAndSecondary: {
                        ...current.unitsCard.firstHeader.mainAndSecondary,
                        elements: current.unitsCard.firstHeader.mainAndSecondary.elements.map((element, itemIndex) => (itemIndex === index ? entity : element)),
                      },
                    },
                  },
                }))}
                lang={context.state.marketplace.language}
                propertyOptions={context.state.placementPropertyOptions}
                moveToTrash={() => moveToTrash(index)}
              />
            </React.Fragment>
          ))}
        </ReactSortable>
      )}
    </>
  );
};
